// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TopInfo_wrapper__PZ29h","basic":"TopInfo_basic__C3Fm6","professional":"TopInfo_professional__1_3Q4","premium":"TopInfo_premium__17NM-"};